import { LitElement, html } from 'lit';
import './layout/app-header.js';
import './layout/app-footer.js';
import './notification-toast.js';
import '../pages/quote-details-page.js';

class AppShell extends LitElement {
    static properties = {
        currentPage: { type: String },
        quoteReference: { type: String },
    };

    // No Shadow DOM - use Light DOM for Tailwind compatibility
    createRenderRoot() {
        return this;
    }

    constructor() {
        super();
        this.currentPage = 'loading';
        this.quoteReference = null;
    }

    render() {
        return html`
            <auth-context-provider>
                <div class="flex flex-col w-full min-h-screen overflow-auto justify-between">
                    <app-header></app-header>
                    <main role="main" class="flex-1 pt-16">
                        <div
                            class="w-full px-4 md:w-11/12 md:mx-auto lg:w-2/3 lg:mx-auto xl:w-1/2 xl:mx-auto"
                        >
                            ${this.renderPage()}
                        </div>
                    </main>
                    <app-footer></app-footer>
                </div>
                <notification-toast></notification-toast>
            </auth-context-provider>
        `;
    }

    renderPage() {
        switch (this.currentPage) {
            case 'sign-in':
                return html`<sign-in-page></sign-in-page>`;
            case 'quote-landing':
                return html`<quote-landing-page></quote-landing-page>`;
            case 'quote-details':
                return html`
                    <quote-details-page
                        .quoteReference="${this.quoteReference}"
                    ></quote-details-page>
                `;
            case 'loading':
                return html`
                    <div class="flex items-center justify-center min-h-[60vh]">
                        <div class="text-center">
                            <span class="loading loading-spinner loading-lg text-peppermint"></span>
                            <p class="mt-4 text-gray-600">Loading...</p>
                        </div>
                    </div>
                `;
            default:
                return html`
                    <div class="text-center min-h-[60vh] flex items-center justify-center">
                        <div>
                            <h1 class="text-2xl font-bold mb-4">Page Not Found</h1>
                            <p class="text-gray-600">The page you're looking for doesn't exist.</p>
                        </div>
                    </div>
                `;
        }
    }
}

customElements.define('app-shell', AppShell);
